module.exports = __webpack_public_path__ + "img/icon_white_invite.d6128b7b.png";